import { render, staticRenderFns } from "./UserActivityLogsView.vue?vue&type=template&id=5a057fdd&scoped=true&"
import script from "./UserActivityLogsView.vue?vue&type=script&lang=ts&"
export * from "./UserActivityLogsView.vue?vue&type=script&lang=ts&"
import style0 from "./UserActivityLogsView.vue?vue&type=style&index=0&id=5a057fdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a057fdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a057fdd')) {
      api.createRecord('5a057fdd', component.options)
    } else {
      api.reload('5a057fdd', component.options)
    }
    module.hot.accept("./UserActivityLogsView.vue?vue&type=template&id=5a057fdd&scoped=true&", function () {
      api.rerender('5a057fdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/activityLogs/UserActivityLogsView.vue"
export default component.exports